@if (link()) {
  <a
    [routerLink]="link()"
    class="menu-item"
    routerLinkActive="menu-item-active"
  >
    <ng-container *ngTemplateOutlet="content" />
  </a>
} @else {
  <span class="menu-item">
    <ng-container *ngTemplateOutlet="content" />
  </span>
}

<ng-template #content>
  <ng-content />
</ng-template>
